import { render, staticRenderFns } from "./post-gallery-modal.vue?vue&type=template&id=043382c8&"
import script from "./post-gallery-modal.vue?vue&type=script&lang=js&"
export * from "./post-gallery-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('043382c8')) {
      api.createRecord('043382c8', component.options)
    } else {
      api.reload('043382c8', component.options)
    }
    module.hot.accept("./post-gallery-modal.vue?vue&type=template&id=043382c8&", function () {
      api.rerender('043382c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/post/gallery/post-gallery-modal.vue"
export default component.exports